module.exports = __webpack_public_path__ + "static/img/icon5.50501f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon5.png
// module id = WUGy
// module chunks = 6